import React, { useState, useEffect } from 'react';
import { useParams, useSearchParams } from 'react-router-dom';
import NoticiasNav from '../../components/noticias/NoticiasNav';
import NoticiaDestacada from '../../components/noticias/NoticiaDestacada';
import NoticiaCard from '../../components/noticias/NoticiaCard';
import bgFlores from '../../assets/images/noticias-bg-flores-black.png';

function NoticiasList() {
  const [noticias, setNoticias] = useState([]);
  const [noticiaDestacada, setNoticiaDestacada] = useState(null);
  const [totalPages, setTotalPages] = useState(0);
  const [searchParams, setSearchParams] = useSearchParams();
  const { tipo } = useParams();
  const currentPage = parseInt(searchParams.get('page')) || 1;

  useEffect(() => {
    const fetchNoticias = async () => {
      try {
        const params = new URLSearchParams();
        
        if (currentPage) {
          params.append('page', currentPage);
        }
        
        if (tipo) {
          params.append('type', tipo.toUpperCase());
        }

        const url = `${process.env.REACT_APP_API_URL}/api/news?${params.toString()}`;
        
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error('Error al cargar las noticias');
        }
        
        const data = await response.json();
        setNoticias(data.news);
        setTotalPages(data.pages);
        
        if (data.news.length > 0) {
          setNoticiaDestacada(data.news[0]);
        } else {
          setNoticiaDestacada(null);
        }
      } catch (error) {
        console.error('Error fetching noticias:', error);
        setNoticias([]);
        setTotalPages(0);
        setNoticiaDestacada(null);
      }
    };

    fetchNoticias();
  }, [tipo, currentPage]);

  const handlePageChange = (newPage) => {
    setSearchParams({ page: newPage.toString() });
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNoticiaSelect = (noticia) => {
    setNoticiaDestacada(noticia);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-brand-dark relative">
      {/* Background pattern */}
      <div 
        className="absolute inset-0 bg-repeat opacity-70" 
        style={{ backgroundImage: `url(${bgFlores})` }}
      />

      {/* Content */}
      <div className="relative">
        <NoticiasNav />
        
        <div className="container mx-auto px-4 py-8">
          <NoticiaDestacada noticia={noticiaDestacada} />
          
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
            {noticias.map((noticia) => (
              <NoticiaCard 
                key={noticia.id} 
                noticia={noticia} 
                onSelect={handleNoticiaSelect}
              />
            ))}
          </div>

          {noticias.length === 0 && (
            <div className="text-center py-12">
              <p className="text-brand-white/70 text-lg">
                No hay noticias disponibles en esta categoría
              </p>
            </div>
          )}

          {totalPages > 1 && (
            <div className="flex justify-center mt-8 gap-2">
              <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className="w-10 h-10 rounded-lg font-medium transition-all duration-200 
                        bg-brand-dark/50 text-brand-white/70 hover:bg-brand-red/20 hover:text-brand-white
                        disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {'<'}
              </button>
              
              {Array.from({ length: totalPages }).map((_, i) => (
                <button
                  key={i + 1}
                  onClick={() => handlePageChange(i + 1)}
                  className={`w-10 h-10 rounded-lg font-medium transition-all duration-200 
                            ${currentPage === i + 1
                              ? 'bg-brand-red text-brand-white'
                              : 'bg-brand-dark/50 text-brand-white/70 hover:bg-brand-red/20 hover:text-brand-white'
                            }`}
                >
                  {i + 1}
                </button>
              ))}

              <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className="w-10 h-10 rounded-lg font-medium transition-all duration-200 
                        bg-brand-dark/50 text-brand-white/70 hover:bg-brand-red/20 hover:text-brand-white
                        disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {'>'}
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default NoticiasList;